export default __webpack_public_path__ + "static/media/formacion.af91116f.png";